import { useTranslation } from 'next-i18next';
import type { ReactElement } from 'react';
import { getCdnTranslationProps } from '../../utils/server/i18n/getCdnTranslationProps';

import { NEXT_PUBLIC_CDN_URL } from '../../../appConfig';
import AppShellLayoutForSSR from '../../components/layout/AppShellLayoutForSSR';
import CustomHead from '../../components/layout/CustomHead';
import { AiInterviewsPageItem } from '../../components/pages/ai-interviews/AiInterviewsPageItem';

export const getServerSideProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await getCdnTranslationProps(locale ?? 'ko', ['common'])),
  },
});

function AiInterviewsPage() {
  const { t } = useTranslation();

  return (
    <>
      <CustomHead
        title={t('ai_interviews.meta.title')}
        description={t('ai_interviews.meta.description')}
        image={`${NEXT_PUBLIC_CDN_URL}/public/static-images/71d6fde4-3044-452f-8887-beeb1cabd80b.png`}
      />
      <AiInterviewsPageItem />
    </>
  );
}

/**
 * @NOTE PlainLayout(=AppShellLayoutForCSR) 은 children 까지 `ssr: false` 서브트리에 들어가
 * 본문이 CSR 로만 렌더되므로, 랜딩 SEO 를 위해 본문을 SSR 하는 이 레이아웃을 쓴다.
 */
AiInterviewsPage.getLayout = (page: ReactElement) => (
  <AppShellLayoutForSSR showChanneltalk={false} footer={{ hasBottomNavigation: false }}>
    {page}
  </AppShellLayoutForSSR>
);

export default AiInterviewsPage;
